import Vue from 'vue'
import 'vueperslides/dist/vueperslides.css'


Vue.mixin({
  computed: {
    gradientBackground() {
      const theme = this.$vuetify.theme
      const gradient = theme.isDark
        ? theme.themes.dark.gradient
        : theme.themes.light.gradient

      return `linear-gradient(to right, ${gradient.gradientDefault1}, ${gradient.gradientDefault2})`
    },
    colorBody() {
      const theme = this.$vuetify.theme
      return theme.isDark ? theme.themes.dark.body : theme.themes.light.body
    },
  },
})
